import { render, staticRenderFns } from "./btra_new.vue?vue&type=template&id=457ebd23"
import script from "./btra_new.vue?vue&type=script&lang=js"
export * from "./btra_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports